<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
			persistent
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition">
      <v-card style="margin: 0px;">
        <v-toolbar class="dialog-toolbar fixNotchPaddingTop">
          <v-btn icon dark @click="close()">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <v-toolbar-title>
						<v-icon color="primary" style="top: -2px;">mdi-cast-education</v-icon>
						Cursos disponibles
					</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text style="padding: 0;" class="fixNotchPaddingTop">
				<div>
					<v-col cols="12" class="pt-0 pb-1 icoev-header-title">					
					<v-text-field 
						light solo flat
						class="search icoev-search-input"
						v-model="search"
						append-icon="mdi-magnify"
						label="Buscar..."
						:disabled="isLoading"
						@keyup="searchTimeOut()"/>
					</v-col>
				</div>					
				<div class="pt-0 dialog-paged-with-search-bk-color" :style="{ paddingBottom: showMoreContent ? '0' : '12px' }">
					<v-skeleton-loader v-if="isLoading" type="list-item-avatardialog-paged-with-search-bk-color" class="mx-auto" max-width="90%" style="padding-top: 20px;"/>
					<v-alert v-if="!isLoading && items.length == 0" type="error" style="margin: 20px;">
						No se han encontrado datos
					</v-alert> 
					
					<!-- Item -->
					<div v-for="item in items" :key="item.id">
						<CourseItem :data="item" @open-external-content="openUrl(arguments)"/>
					</div>

					<v-row v-if="showMoreContent">
						<v-col style="text-align: center;">
							<a @click="addMoreContent()">Mostrar más contenido</a>
						</v-col>
					</v-row> 
            </div> 
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import api from '../../api/icoev';
import BaseModule from "./BaseModule";
import CourseItem from "./CourseItem";

export default {
	name: "FormacionDialog",
	mixins: [ BaseModule ],
	components: {
		CourseItem
	},
	data() {
		return {
			isLoading: false,
			dialog: false,
			search: '',
			page: 0,
			showMoreContent: false,
			items: [],
			selector: null,
		}
	},
	methods: {
		open: function() {
			this.page = 0;
			this.showMoreContent = false;
			this.items = [];

			this.dialog = true;

			this.$nextTick(() => {
				this.listarItems();
			});
		},
		isOpen: function() {
			return this.dialog;
		},
		close: function() {
			this.dialog = false;
		},
		searchTimeOut() {
			if (this.timer) {
				clearTimeout(this.timer);
				this.timer = null;
			}
			this.timer = setTimeout(() => {
					this.page = 0;
					this.showMoreContent = false;
					this.items = [];

					this.listarItems();
			}, 800);
		},    
		listarItems: function() {
			this.$log.debug("FormacionDialog - listarItems()");

			this.isLoading = true;

			api.getCourses(this.page, this.search ? this.search : '',
				res => {
					this.isLoading = false;

					if (!res.rsOK) {
						this.$emit('alert-event', { text: res.message, color: 'error', timeout: 3000 });
						return;
					}
					
					this.lastUpdate = new Date();

					if (res.entities.length == 0) {
						return;
					}
				
					this.items.push(...res.entities);

					this.showMoreContent = res.hasMoreData;

					if (!this.selector) {
						this.selector = '#course' + this.items[0].id;
					}					
					
					if (this.selector) {
						this.$nextTick(() => {
							var anchor = this.$el.querySelector(this.selector);
							if (anchor) {
								anchor.scrollIntoView();
							}
						});
					}										
				},
				err => {               
					this.isLoading = false;     
					this.$log.error(err);
					this.$emit('alert-event', { text: 'Error al actualizar los cursos de formación', color: 'error', timeout: 3000 });
				}
			);
		},
		addMoreContent: function() {
			this.page++;
			this.selector = '#course' + this.items[this.items.length - 1].id;
			this.showMoreContent = false;

			this.listarItems();
		},
		openUrl(args) {
			this.$emit('open-external-content', args[0], args[1]);
		},
		reset() {			
			this.search = '';
			this.page = 0;
			this.items = [];
			this.selector = null;
			this.showMoreContent = false;
			this.isDirty = true;
		}
	},
	computed: {
		userChanged() {
			return this.$store.state.icoev.user;
		}
	},
	watch: {
		userChanged() {
			this.reset();
		},
	},
}
</script>